<template>
    <div class="menu-button-container">
        <button class="draggable-item-menu-btn draggable-item-menu-btn-blue draggable-item-menu-btn-view" @click="view">
            Ver
        </button>
    </div>
</template>

<script>
export default {
    name: "ViewOrderReferenceButton",
    props: {
        orderReferenceId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        view() {
            window.open(`/order-reference-view/${this.orderReferenceId}`, '_self')
        },
    },
};
</script>